import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../../common/EnhancedTableHead';

interface Props {
  approvals: any[];
}

const headRows: HeadRow[] = [
  { id: 'deck', disablePadding: false, label: 'Deck' },
  { id: 'version', disablePadding: false, label: 'Version' },
  { id: 'approver', disablePadding: false, label: 'Approver' },
  { id: 'approvalTime', disablePadding: false, label: 'Approval Decision Time' }
];

function HistoryTable(props: Props) {
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('approvalTime');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(props.approvals, getSorting(order, orderBy));

  return (
    <Table>
      <EnhancedTableHead
        order={order}
        orderBy={orderBy}
        fields={headRows}
        onRequestSort={handleRequestSort}
      />
      <TableBody>
        {sortedRows.map(row => (
          <TableRow key={row.id}>
            <TableCell>{row.deck}</TableCell>
            <TableCell>{row.version}</TableCell>
            <TableCell>{row.approver}</TableCell>
            <TableCell>{moment(row.approvalTime).format('ddd, MMM Do YYYY, HH:mm z')} {moment.tz.zone(moment.tz.guess()).abbr(row.approvalTime)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default HistoryTable;
